import { ReactNode, createContext, useContext, useState } from 'react';
import Notification from 'models/Notifications/Notification';

type NotificationContextProviderProps = {
  children: ReactNode;
}

export type NotificationContextData = {
  hasNotifications: boolean,
  notifications: Notification[],
  setHasNotifications: (hasNotifications: boolean) => void,
  setNotifications: (notification: Notification[]) => void,
  setAllAsRead: () => void,
  setAsRead: (id: number) => void
};

export const NotificationContext = createContext({} as NotificationContextData);

export function NotificationContextProvider({ children }: NotificationContextProviderProps) : JSX.Element {
  const [hasNotifications, setHasNotifications] = useState<boolean>(false);
  const [notifications, setNotifications] = useState<Array<Notification>>([]);

  const setAllAsRead = () : void => {
    setNotifications(notifications.map(x => ({ ...x, read: true })));
    setHasNotifications(false);
  };

  const setAsRead = (id: number) : void => {
    setNotifications(notifications.map(x => x.id === id ? { ...x, read: true } : x));
  };

  return (
    <NotificationContext.Provider
      value={{
        hasNotifications,
        notifications,
        setHasNotifications,
        setNotifications,
        setAllAsRead,
        setAsRead

      }}
    >
      {children}
    </NotificationContext.Provider>
  );
}

export const useNotifications = () : NotificationContextData => {
  return useContext(NotificationContext);
};